const uiConstants = {
  CHANGE_PAGE_TITLE: 'PAGE_TITLE',
  CHANGE_DARK_MODE: 'CHANGE_DARK_MODE',
  SET_CURRENT_GROUP: 'UI_SET_CURRENT_GROUP',
};

export default uiConstants;
